module.exports = __webpack_public_path__ + "img/logo_flypaypro.a077196b.png";